import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { Attendee } from 'globals/store/attendees.data';
import { attendeeTemplateReselector } from '../../store/reselectors/entity.reselector';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { ManageContactDetailsComponent } from 'src/app/modules/manage/manage-contact-details.component';

@Component({
    selector: 'manage-template-attendee',
    templateUrl: './manage-template-attendee.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, ManageContactDetailsComponent],
})
export class ManageTemplateAttendee extends ManageTemplateWrapper<Attendee> implements OnInit {
  _file = 'manage-template-attendee'

  ngOnInit() {
    this.clipboardKey = 'attendees'
    this.selectProp(attendeeTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId}, 'entity')
  }

}
